import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as AnnouncementService from 'services/iam/announcement';

export const useAnnouncementService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchAnnouncements = async (options = {}) => {
    const { error, payload } = await AnnouncementService.read({ ...options, token });
    if (error || !payload) {
      return { announcements: [], size: 0 };
    }

    const announcements = Array.isArray(payload) ? payload : payload.data || [];
    const size = Array.isArray(payload)
      ? payload.length
      : payload.meta?.size ?? announcements.length;
    return { announcements, size };
  };

  const fetchAnnouncement = async (id, options = {}) => {
    const { payload } = await AnnouncementService.readById(id, { ...options, token });
    return { announcement: payload };
  };

  const createAnnouncement = async (options = {}) => {
    const { error, payload: announcement } = await AnnouncementService.create({
      ...options,
      token
    });

    if (error) {
      toast.error('Cannot create announcement at this time.');
      return { announcement: {} };
    }

    toast.success('Announcement created successfully.');
    return { announcement };
  };

  const updateAnnouncement = async (id, options = {}) => {
    const { error, payload: announcement } = await AnnouncementService.updateById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Cannot update announcement at this time.');
      return { announcement: {} };
    }

    toast.success('Announcement updated successfully.');
    return { announcement };
  };

  const deleteAnnouncement = async (id, options = {}) => {
    const { error } = await AnnouncementService.deleteById(id, { ...options, token });
    if (error) {
      toast.error('Cannot delete announcement at this time.');
      return false;
    }

    toast.success('Announcement deleted successfully.');
    return true;
  };

  return {
    fetchAnnouncements,
    fetchAnnouncement,
    createAnnouncement,
    updateAnnouncement,
    deleteAnnouncement
  };
};
